// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { HealthControllerHealthData, HealthControllerHealthResponses, AuthControllerLoginData, AuthControllerLoginResponses, AuthControllerLogoutData, AuthControllerLogoutResponses, AuthControllerStopImpersonatingData, AuthControllerStopImpersonatingResponses, AuthControllerDeleteData, AuthControllerDeleteResponses, OrganizationControllerGetData, OrganizationControllerGetResponses, OrganizationControllerUpdateSettingsData, OrganizationControllerUpdateSettingsResponses, ProductControllerListData, ProductControllerListResponses, ProductControllerGetData, ProductControllerGetResponses, ProductControllerGetImagesData, ProductControllerGetImagesResponses, ProductControllerSetAttentionData, ProductControllerSetAttentionResponses, ProductControllerSetImageAttentionData, ProductControllerSetImageAttentionResponses, ProductControllerDeleteData, ProductControllerDeleteResponses, ProductControllerDeleteImageData, ProductControllerDeleteImageResponses, LogControllerTestData, LogControllerTestResponses, LogControllerFailData, LogControllerFailResponses, AdminUserControllerListData, AdminUserControllerListResponses, AdminProductControllerListData, AdminProductControllerListResponses, AdminProductControllerGetData, AdminProductControllerGetResponses, AdminOrganizationControllerListData, AdminOrganizationControllerListResponses, AdminDeviceSessionsControllerListData, AdminDeviceSessionsControllerListResponses, AdminTransactionControllerListData, AdminTransactionControllerListResponses, AdminNewUserControllerListData, AdminNewUserControllerListResponses, AdminUnclaimedStripePaymentControllerListData, AdminUnclaimedStripePaymentControllerListResponses, AdminChatConfigControllerGetData, AdminChatConfigControllerGetResponses, AdminChatConfigControllerUpdateData, AdminChatConfigControllerUpdateResponses, AppControllerChallengeData, AppControllerChallengeResponses, AppControllerGetVersionInfoData, AppControllerGetVersionInfoResponses, AppControllerVerifyAttestationData, AppControllerVerifyAttestationResponses, AppControllerGetAvailableCreditsData, AppControllerGetAvailableCreditsResponses, AppControllerRedeemCodeData, AppControllerRedeemCodeResponses, AppControllerConfigData, AppControllerConfigResponses, AppControllerUploadImageVersionData, AppControllerUploadImageVersionResponses, AppControllerPushChangesData, AppControllerPushChangesResponses, AppControllerExportData, AppControllerExportResponses, AppControllerIntegrationsData, AppControllerIntegrationsResponses, ExportControllerGetImageData, ExportControllerGetImageResponses, ExportControllerListExportTasksData, ExportControllerListExportTasksResponses, ExportControllerGetExportErrorsData, ExportControllerGetExportErrorsResponses, ExportControllerCancelExportTaskData, ExportControllerCancelExportTaskResponses, ExportControllerDismissExportTaskData, ExportControllerDismissExportTaskResponses, WebarealControllerInstallData, WebarealControllerInstallResponses, ShoptetControllerInstallData, ShoptetControllerInstallResponses, ShoptetControllerVerifyCodeData, ShoptetControllerVerifyCodeResponses, ShoptetControllerInitiateConnectData, ShoptetControllerInitiateConnectResponses, ShoptetControllerFinishConnectData, ShoptetControllerFinishConnectResponses, ShoptetControllerDisconnectData, ShoptetControllerDisconnectResponses, ShoptetControllerListConnectionsData, ShoptetControllerListConnectionsResponses, ShoptetControllerWebhookData, ShoptetControllerWebhookResponses, ShoptetControllerGetSettingsData, ShoptetControllerGetSettingsResponses, ShoptetControllerUpdateSettingsData, ShoptetControllerUpdateSettingsResponses, DeprecatedProcessImageControllerPlusData, DeprecatedProcessImageControllerPlusResponses, DeprecatedProcessImageControllerBasicData, DeprecatedProcessImageControllerBasicResponses, DeprecatedProcessImageControllerApplyToolData, DeprecatedProcessImageControllerApplyToolResponses, DeprecatedProcessImageControllerAiMagicData, DeprecatedProcessImageControllerAiMagicResponses, DeprecatedProcessImageControllerExtractBookCoverData, DeprecatedProcessImageControllerExtractBookCoverResponses, UserControllerListData, UserControllerListResponses, UserControllerRemoveAccessData, UserControllerRemoveAccessResponses, UserControllerAddAccessData, UserControllerAddAccessResponses, ApiKeyControllerListData, ApiKeyControllerListResponses, ApiKeyControllerCreateData, ApiKeyControllerCreateResponses, ApiKeyControllerRemoveData, ApiKeyControllerRemoveResponses, UsageControllerGetLast31DaysUsageData, UsageControllerGetLast31DaysUsageResponses, UsageControllerGetLast3MonthsUsageData, UsageControllerGetLast3MonthsUsageResponses, ImageControllerDownloadProblematicImagesData, ImageControllerDownloadProblematicImagesResponses, ImageControllerUploadImagesData, ImageControllerUploadImagesResponses, ShoptetExternalProductControllerFetchExternalProductsData, ShoptetExternalProductControllerFetchExternalProductsResponses, ShoptetExternalProductControllerFetchExternalProductImagesData, ShoptetExternalProductControllerFetchExternalProductImagesResponses, ShoptetExternalProductControllerUploadExternalProductImageData, ShoptetExternalProductControllerUploadExternalProductImageResponses, ExternalProductControllerListData, ExternalProductControllerListResponses, ExternalProductControllerGetTagsData, ExternalProductControllerGetTagsResponses, ExternalProductControllerListImagesData, ExternalProductControllerListImagesResponses, ExternalProductControllerGetData, ExternalProductControllerGetResponses, ExternalProductControllerProcessImageData, ExternalProductControllerProcessImageResponses, ExternalProductControllerBulkActionData, ExternalProductControllerBulkActionResponses, ImageEditControllerRestartImageEditsData, ImageEditControllerRestartImageEditsResponses, ProcessingControllerGetPriceData, ProcessingControllerGetPriceResponses, ProcessingControllerProcessData, ProcessingControllerProcessResponses, StripeControllerHandleWebhookData, StripeControllerHandleWebhookResponses, TaskPlanControllerGetProductWorkflowData, TaskPlanControllerGetProductWorkflowResponses, TaskPlanControllerGetImageWorkflowData, TaskPlanControllerGetImageWorkflowResponses, TaskPlanControllerRerunPlanData, TaskPlanControllerRerunPlanResponses, TaskPlanControllerOverrideNodeData, TaskPlanControllerOverrideNodeResponses, LostFoundControllerGetPendingData, LostFoundControllerGetPendingResponses, LostFoundControllerUploadImageVersionData, LostFoundControllerUploadImageVersionResponses, LostFoundControllerReportProductImagesData, LostFoundControllerReportProductImagesResponses, LostFoundControllerFailTaskData, LostFoundControllerFailTaskResponses, ChatControllerMessageData, ChatControllerMessageResponses, TemplatesControllerListData, TemplatesControllerListResponses, TemplatesControllerCreateData, TemplatesControllerCreateResponses, MakeControllerConnectData, MakeControllerConnectResponses, MakeControllerGetSettingsData, MakeControllerGetSettingsResponses, MakeControllerUpdateSettingsData, MakeControllerUpdateSettingsResponses, MakeControllerDeleteIntegrationData, MakeControllerDeleteIntegrationResponses, V1ControllerFeedCsvData, V1ControllerFeedCsvResponses, V1ControllerFeedCsvErrors, V1ControllerFeedJsonData, V1ControllerFeedJsonResponses, V1ControllerFeedJsonErrors, AiCrewControllerHealthData, AiCrewControllerHealthResponses, AiCrewControllerImagesByPaymentSourceData, AiCrewControllerImagesByPaymentSourceResponses, AiCrewControllerListOrganizationsData, AiCrewControllerListOrganizationsResponses, AiCrewControllerListProductsData, AiCrewControllerListProductsResponses, AiCrewControllerGetProductData, AiCrewControllerGetProductResponses, AiCrewControllerListProductImagesData, AiCrewControllerListProductImagesResponses, AiCrewControllerListExportTasksData, AiCrewControllerListExportTasksResponses, AiCrewControllerListExportTaskErrorsData, AiCrewControllerListExportTaskErrorsResponses, AiCrewControllerListExportErrorsData, AiCrewControllerListExportErrorsResponses, AiCrewControllerListUsersData, AiCrewControllerListUsersResponses, AiCrewControllerListNewUsersData, AiCrewControllerListNewUsersResponses, AiCrewControllerListTransactionsData, AiCrewControllerListTransactionsResponses, AiCrewControllerListDeviceSessionsData, AiCrewControllerListDeviceSessionsResponses, AiCrewControllerGetProcessingOptionsOverviewData, AiCrewControllerGetProcessingOptionsOverviewResponses, AiCrewControllerListUnclaimedStripePaymentsData, AiCrewControllerListUnclaimedStripePaymentsResponses, AiCrewProcessingControllerGetPriceData, AiCrewProcessingControllerGetPriceResponses, AiCrewProcessingControllerProcessData, AiCrewProcessingControllerProcessResponses, OauthControllerAuthorizeContextData, OauthControllerAuthorizeContextResponses, OauthControllerDecideData, OauthControllerDecideResponses, OauthControllerListSessionsData, OauthControllerListSessionsResponses, OauthControllerRevokeSessionData, OauthControllerRevokeSessionResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const healthControllerHealth = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthControllerHealthResponses, unknown, ThrowOnError>({
        url: '/api/health',
        ...options
    });
};

export const authControllerLogin = <ThrowOnError extends boolean = false>(options: Options<AuthControllerLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthControllerLoginResponses, unknown, ThrowOnError>({
        url: '/api/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authControllerLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerLogoutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AuthControllerLogoutResponses, unknown, ThrowOnError>({
        url: '/api/auth/logout',
        ...options
    });
};

export const authControllerStopImpersonating = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerStopImpersonatingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AuthControllerStopImpersonatingResponses, unknown, ThrowOnError>({
        url: '/api/auth/stop-impersonating',
        ...options
    });
};

export const authControllerDelete = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<AuthControllerDeleteResponses, unknown, ThrowOnError>({
        url: '/api/auth/delete',
        ...options
    });
};

export const organizationControllerGet = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<OrganizationControllerGetResponses, unknown, ThrowOnError>({
        url: '/api/organizations/{id}',
        ...options
    });
};

export const organizationControllerUpdateSettings = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerUpdateSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<OrganizationControllerUpdateSettingsResponses, unknown, ThrowOnError>({
        url: '/api/organizations/{id}/update-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productControllerList = <ThrowOnError extends boolean = false>(options: Options<ProductControllerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductControllerListResponses, unknown, ThrowOnError>({
        url: '/api/products/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productControllerGet = <ThrowOnError extends boolean = false>(options: Options<ProductControllerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductControllerGetResponses, unknown, ThrowOnError>({
        url: '/api/products/{id}',
        ...options
    });
};

export const productControllerGetImages = <ThrowOnError extends boolean = false>(options: Options<ProductControllerGetImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductControllerGetImagesResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}/images',
        ...options
    });
};

export const productControllerSetAttention = <ThrowOnError extends boolean = false>(options: Options<ProductControllerSetAttentionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductControllerSetAttentionResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}/set-attention',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productControllerSetImageAttention = <ThrowOnError extends boolean = false>(options: Options<ProductControllerSetImageAttentionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductControllerSetImageAttentionResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}/images/{imageId}/set-attention',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productControllerDelete = <ThrowOnError extends boolean = false>(options: Options<ProductControllerDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProductControllerDeleteResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}',
        ...options
    });
};

export const productControllerDeleteImage = <ThrowOnError extends boolean = false>(options: Options<ProductControllerDeleteImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProductControllerDeleteImageResponses, unknown, ThrowOnError>({
        url: '/api/products/{productId}/images/{imageId}',
        ...options
    });
};

export const logControllerTest = <ThrowOnError extends boolean = false>(options?: Options<LogControllerTestData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LogControllerTestResponses, unknown, ThrowOnError>({
        url: '/api/log/test',
        ...options
    });
};

export const logControllerFail = <ThrowOnError extends boolean = false>(options?: Options<LogControllerFailData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LogControllerFailResponses, unknown, ThrowOnError>({
        url: '/api/log/fail',
        ...options
    });
};

export const adminUserControllerList = <ThrowOnError extends boolean = false>(options?: Options<AdminUserControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminUserControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/users',
        ...options
    });
};

export const adminProductControllerList = <ThrowOnError extends boolean = false>(options: Options<AdminProductControllerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AdminProductControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/products/list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const adminProductControllerGet = <ThrowOnError extends boolean = false>(options: Options<AdminProductControllerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AdminProductControllerGetResponses, unknown, ThrowOnError>({
        url: '/api/admin/products/{id}',
        ...options
    });
};

export const adminOrganizationControllerList = <ThrowOnError extends boolean = false>(options?: Options<AdminOrganizationControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminOrganizationControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/organizations',
        ...options
    });
};

export const adminDeviceSessionsControllerList = <ThrowOnError extends boolean = false>(options?: Options<AdminDeviceSessionsControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminDeviceSessionsControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/device-sessions',
        ...options
    });
};

export const adminTransactionControllerList = <ThrowOnError extends boolean = false>(options?: Options<AdminTransactionControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminTransactionControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/transactions',
        ...options
    });
};

export const adminNewUserControllerList = <ThrowOnError extends boolean = false>(options?: Options<AdminNewUserControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminNewUserControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/users/new',
        ...options
    });
};

export const adminUnclaimedStripePaymentControllerList = <ThrowOnError extends boolean = false>(options?: Options<AdminUnclaimedStripePaymentControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminUnclaimedStripePaymentControllerListResponses, unknown, ThrowOnError>({
        url: '/api/admin/unclaimed-stripe-payments',
        ...options
    });
};

export const adminChatConfigControllerGet = <ThrowOnError extends boolean = false>(options?: Options<AdminChatConfigControllerGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminChatConfigControllerGetResponses, unknown, ThrowOnError>({
        url: '/api/admin/chat-config',
        ...options
    });
};

export const adminChatConfigControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminChatConfigControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AdminChatConfigControllerUpdateResponses, unknown, ThrowOnError>({
        url: '/api/admin/chat-config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerChallenge = <ThrowOnError extends boolean = false>(options?: Options<AppControllerChallengeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AppControllerChallengeResponses, unknown, ThrowOnError>({
        url: '/api/app/challenge',
        ...options
    });
};

export const appControllerGetVersionInfo = <ThrowOnError extends boolean = false>(options?: Options<AppControllerGetVersionInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppControllerGetVersionInfoResponses, unknown, ThrowOnError>({
        url: '/api/app/version-info',
        ...options
    });
};

export const appControllerVerifyAttestation = <ThrowOnError extends boolean = false>(options: Options<AppControllerVerifyAttestationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerVerifyAttestationResponses, unknown, ThrowOnError>({
        url: '/api/app/verify-attestation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerGetAvailableCredits = <ThrowOnError extends boolean = false>(options: Options<AppControllerGetAvailableCreditsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerGetAvailableCreditsResponses, unknown, ThrowOnError>({
        url: '/api/app/available-credits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerRedeemCode = <ThrowOnError extends boolean = false>(options: Options<AppControllerRedeemCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerRedeemCodeResponses, unknown, ThrowOnError>({
        url: '/api/app/redeem-code',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerConfig = <ThrowOnError extends boolean = false>(options?: Options<AppControllerConfigData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppControllerConfigResponses, unknown, ThrowOnError>({
        url: '/api/app/config',
        ...options
    });
};

export const appControllerUploadImageVersion = <ThrowOnError extends boolean = false>(options: Options<AppControllerUploadImageVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerUploadImageVersionResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/app/upload-image-version',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const appControllerPushChanges = <ThrowOnError extends boolean = false>(options: Options<AppControllerPushChangesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerPushChangesResponses, unknown, ThrowOnError>({
        url: '/api/app/push-changes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerExport = <ThrowOnError extends boolean = false>(options: Options<AppControllerExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppControllerExportResponses, unknown, ThrowOnError>({
        url: '/api/app/export',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appControllerIntegrations = <ThrowOnError extends boolean = false>(options?: Options<AppControllerIntegrationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppControllerIntegrationsResponses, unknown, ThrowOnError>({
        url: '/api/app/integrations',
        ...options
    });
};

export const exportControllerGetImage = <ThrowOnError extends boolean = false>(options: Options<ExportControllerGetImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExportControllerGetImageResponses, unknown, ThrowOnError>({
        url: '/api/export/image/{imageVersionId}/{filename}',
        ...options
    });
};

export const exportControllerListExportTasks = <ThrowOnError extends boolean = false>(options?: Options<ExportControllerListExportTasksData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExportControllerListExportTasksResponses, unknown, ThrowOnError>({
        url: '/api/export/export-tasks',
        ...options
    });
};

export const exportControllerGetExportErrors = <ThrowOnError extends boolean = false>(options: Options<ExportControllerGetExportErrorsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExportControllerGetExportErrorsResponses, unknown, ThrowOnError>({
        url: '/api/export/export-tasks/{id}/errors',
        ...options
    });
};

export const exportControllerCancelExportTask = <ThrowOnError extends boolean = false>(options: Options<ExportControllerCancelExportTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExportControllerCancelExportTaskResponses, unknown, ThrowOnError>({
        url: '/api/export/export-tasks/{id}/cancel',
        ...options
    });
};

export const exportControllerDismissExportTask = <ThrowOnError extends boolean = false>(options: Options<ExportControllerDismissExportTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExportControllerDismissExportTaskResponses, unknown, ThrowOnError>({
        url: '/api/export/export-tasks/{id}/dismiss',
        ...options
    });
};

export const webarealControllerInstall = <ThrowOnError extends boolean = false>(options?: Options<WebarealControllerInstallData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<WebarealControllerInstallResponses, unknown, ThrowOnError>({
        url: '/api/integrations/webareal/install',
        ...options
    });
};

export const shoptetControllerInstall = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerInstallData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ShoptetControllerInstallResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/install',
        ...options
    });
};

export const shoptetControllerVerifyCode = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerVerifyCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerVerifyCodeResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/verify-code',
        ...options
    });
};

export const shoptetControllerInitiateConnect = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerInitiateConnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerInitiateConnectResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/initiate-connect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const shoptetControllerFinishConnect = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerFinishConnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerFinishConnectResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/finish-connect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const shoptetControllerDisconnect = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerDisconnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerDisconnectResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/disconnect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const shoptetControllerListConnections = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerListConnectionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetControllerListConnectionsResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/connections',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const shoptetControllerWebhook = <ThrowOnError extends boolean = false>(options?: Options<ShoptetControllerWebhookData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ShoptetControllerWebhookResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/webhook',
        ...options
    });
};

export const shoptetControllerGetSettings = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerGetSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ShoptetControllerGetSettingsResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/settings/{integrationId}',
        ...options
    });
};

export const shoptetControllerUpdateSettings = <ThrowOnError extends boolean = false>(options: Options<ShoptetControllerUpdateSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ShoptetControllerUpdateSettingsResponses, unknown, ThrowOnError>({
        url: '/api/integrations/shoptet/settings/{integrationId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerPlus = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerPlusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerPlusResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/plus',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerBasic = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerBasicData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerBasicResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/basic',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerApplyTool = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerApplyToolData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerApplyToolResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/apply-tool',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerAiMagic = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerAiMagicData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerAiMagicResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/ai-magic',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const deprecatedProcessImageControllerExtractBookCover = <ThrowOnError extends boolean = false>(options: Options<DeprecatedProcessImageControllerExtractBookCoverData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeprecatedProcessImageControllerExtractBookCoverResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/process-image/extract-book-cover',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const userControllerList = <ThrowOnError extends boolean = false>(options?: Options<UserControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserControllerListResponses, unknown, ThrowOnError>({
        url: '/api/users',
        ...options
    });
};

export const userControllerRemoveAccess = <ThrowOnError extends boolean = false>(options: Options<UserControllerRemoveAccessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<UserControllerRemoveAccessResponses, unknown, ThrowOnError>({
        url: '/api/users/access',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const userControllerAddAccess = <ThrowOnError extends boolean = false>(options: Options<UserControllerAddAccessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserControllerAddAccessResponses, unknown, ThrowOnError>({
        url: '/api/users/access',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const apiKeyControllerList = <ThrowOnError extends boolean = false>(options?: Options<ApiKeyControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ApiKeyControllerListResponses, unknown, ThrowOnError>({
        url: '/api/api-keys',
        ...options
    });
};

export const apiKeyControllerCreate = <ThrowOnError extends boolean = false>(options: Options<ApiKeyControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiKeyControllerCreateResponses, unknown, ThrowOnError>({
        url: '/api/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const apiKeyControllerRemove = <ThrowOnError extends boolean = false>(options: Options<ApiKeyControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiKeyControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/api/api-keys/{id}',
        ...options
    });
};

export const usageControllerGetLast31DaysUsage = <ThrowOnError extends boolean = false>(options: Options<UsageControllerGetLast31DaysUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UsageControllerGetLast31DaysUsageResponses, unknown, ThrowOnError>({
        url: '/api/usage/last-31-days',
        ...options
    });
};

export const usageControllerGetLast3MonthsUsage = <ThrowOnError extends boolean = false>(options: Options<UsageControllerGetLast3MonthsUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UsageControllerGetLast3MonthsUsageResponses, unknown, ThrowOnError>({
        url: '/api/usage/last-3-months',
        ...options
    });
};

export const imageControllerDownloadProblematicImages = <ThrowOnError extends boolean = false>(options: Options<ImageControllerDownloadProblematicImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ImageControllerDownloadProblematicImagesResponses, unknown, ThrowOnError>({
        url: '/api/images/download-problematic-images',
        ...options
    });
};

export const imageControllerUploadImages = <ThrowOnError extends boolean = false>(options?: Options<ImageControllerUploadImagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ImageControllerUploadImagesResponses, unknown, ThrowOnError>({
        url: '/api/images/upload',
        ...options
    });
};

export const shoptetExternalProductControllerFetchExternalProducts = <ThrowOnError extends boolean = false>(options?: Options<ShoptetExternalProductControllerFetchExternalProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ShoptetExternalProductControllerFetchExternalProductsResponses, unknown, ThrowOnError>({
        url: '/api/external-products/shoptet-external-product/fetch-external-products',
        ...options
    });
};

export const shoptetExternalProductControllerFetchExternalProductImages = <ThrowOnError extends boolean = false>(options?: Options<ShoptetExternalProductControllerFetchExternalProductImagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ShoptetExternalProductControllerFetchExternalProductImagesResponses, unknown, ThrowOnError>({
        url: '/api/external-products/shoptet-external-product/fetch-external-product-images',
        ...options
    });
};

export const shoptetExternalProductControllerUploadExternalProductImage = <ThrowOnError extends boolean = false>(options: Options<ShoptetExternalProductControllerUploadExternalProductImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShoptetExternalProductControllerUploadExternalProductImageResponses, unknown, ThrowOnError>({
        url: '/api/external-products/shoptet-external-product/upload-external-product-image/{id}',
        ...options
    });
};

export const externalProductControllerList = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExternalProductControllerListResponses, unknown, ThrowOnError>({
        url: '/api/external-products',
        ...options
    });
};

export const externalProductControllerGetTags = <ThrowOnError extends boolean = false>(options?: Options<ExternalProductControllerGetTagsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExternalProductControllerGetTagsResponses, unknown, ThrowOnError>({
        url: '/api/external-products/tags',
        ...options
    });
};

export const externalProductControllerListImages = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerListImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExternalProductControllerListImagesResponses, unknown, ThrowOnError>({
        url: '/api/external-products/images',
        ...options
    });
};

export const externalProductControllerGet = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExternalProductControllerGetResponses, unknown, ThrowOnError>({
        url: '/api/external-products/{id}',
        ...options
    });
};

export const externalProductControllerProcessImage = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerProcessImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExternalProductControllerProcessImageResponses, unknown, ThrowOnError>({
        url: '/api/external-products/process-image/{id}',
        ...options
    });
};

export const externalProductControllerBulkAction = <ThrowOnError extends boolean = false>(options: Options<ExternalProductControllerBulkActionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExternalProductControllerBulkActionResponses, unknown, ThrowOnError>({
        url: '/api/external-products/bulk-action',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Restart failed image edit operations
 * Restarts image edit tasks that have errors and were started. Only selects tasks created from the specified date onwards.
 */
export const imageEditControllerRestartImageEdits = <ThrowOnError extends boolean = false>(options: Options<ImageEditControllerRestartImageEditsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImageEditControllerRestartImageEditsResponses, unknown, ThrowOnError>({
        url: '/api/image-edit/restart',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const processingControllerGetPrice = <ThrowOnError extends boolean = false>(options: Options<ProcessingControllerGetPriceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcessingControllerGetPriceResponses, unknown, ThrowOnError>({
        url: '/api/processing/price',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const processingControllerProcess = <ThrowOnError extends boolean = false>(options: Options<ProcessingControllerProcessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcessingControllerProcessResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/processing/process',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const stripeControllerHandleWebhook = <ThrowOnError extends boolean = false>(options: Options<StripeControllerHandleWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<StripeControllerHandleWebhookResponses, unknown, ThrowOnError>({
        url: '/api/stripe/webhook',
        ...options
    });
};

export const taskPlanControllerGetProductWorkflow = <ThrowOnError extends boolean = false>(options: Options<TaskPlanControllerGetProductWorkflowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TaskPlanControllerGetProductWorkflowResponses, unknown, ThrowOnError>({
        url: '/api/workflow/product/{productId}',
        ...options
    });
};

export const taskPlanControllerGetImageWorkflow = <ThrowOnError extends boolean = false>(options: Options<TaskPlanControllerGetImageWorkflowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TaskPlanControllerGetImageWorkflowResponses, unknown, ThrowOnError>({
        url: '/api/workflow/image/{imageId}',
        ...options
    });
};

export const taskPlanControllerRerunPlan = <ThrowOnError extends boolean = false>(options: Options<TaskPlanControllerRerunPlanData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TaskPlanControllerRerunPlanResponses, unknown, ThrowOnError>({
        url: '/api/workflow/plan/{planId}/rerun',
        ...options
    });
};

export const taskPlanControllerOverrideNode = <ThrowOnError extends boolean = false>(options: Options<TaskPlanControllerOverrideNodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TaskPlanControllerOverrideNodeResponses, unknown, ThrowOnError>({
        url: '/api/workflow/plan/{planId}/node/{nodeId}/override',
        ...options
    });
};

export const lostFoundControllerGetPending = <ThrowOnError extends boolean = false>(options?: Options<LostFoundControllerGetPendingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LostFoundControllerGetPendingResponses, unknown, ThrowOnError>({
        url: '/api/app/lost-found/pending',
        ...options
    });
};

export const lostFoundControllerUploadImageVersion = <ThrowOnError extends boolean = false>(options: Options<LostFoundControllerUploadImageVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LostFoundControllerUploadImageVersionResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/api/app/lost-found/upload-image-version',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const lostFoundControllerReportProductImages = <ThrowOnError extends boolean = false>(options: Options<LostFoundControllerReportProductImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LostFoundControllerReportProductImagesResponses, unknown, ThrowOnError>({
        url: '/api/app/lost-found/report-product-images',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const lostFoundControllerFailTask = <ThrowOnError extends boolean = false>(options: Options<LostFoundControllerFailTaskData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LostFoundControllerFailTaskResponses, unknown, ThrowOnError>({
        url: '/api/app/lost-found/fail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const chatControllerMessage = <ThrowOnError extends boolean = false>(options: Options<ChatControllerMessageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChatControllerMessageResponses, unknown, ThrowOnError>({
        url: '/api/chat/message',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const templatesControllerList = <ThrowOnError extends boolean = false>(options?: Options<TemplatesControllerListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TemplatesControllerListResponses, unknown, ThrowOnError>({
        url: '/api/templates',
        ...options
    });
};

export const templatesControllerCreate = <ThrowOnError extends boolean = false>(options: Options<TemplatesControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TemplatesControllerCreateResponses, unknown, ThrowOnError>({
        url: '/api/templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const makeControllerConnect = <ThrowOnError extends boolean = false>(options: Options<MakeControllerConnectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MakeControllerConnectResponses, unknown, ThrowOnError>({
        url: '/api/integrations/make/connect',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const makeControllerGetSettings = <ThrowOnError extends boolean = false>(options: Options<MakeControllerGetSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MakeControllerGetSettingsResponses, unknown, ThrowOnError>({
        url: '/api/integrations/make/settings/{integrationId}',
        ...options
    });
};

export const makeControllerUpdateSettings = <ThrowOnError extends boolean = false>(options: Options<MakeControllerUpdateSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<MakeControllerUpdateSettingsResponses, unknown, ThrowOnError>({
        url: '/api/integrations/make/settings/{integrationId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const makeControllerDeleteIntegration = <ThrowOnError extends boolean = false>(options: Options<MakeControllerDeleteIntegrationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<MakeControllerDeleteIntegrationResponses, unknown, ThrowOnError>({
        url: '/api/integrations/make/{integrationId}',
        ...options
    });
};

/**
 * Get product feed as CSV
 * Retrieves a CSV feed of product images. Returns all images for up to 30,000 products. Only products with at least one image modified since the date specified are included. Supports pagination via limit and offset.
 */
export const v1ControllerFeedCsv = <ThrowOnError extends boolean = false>(options: Options<V1ControllerFeedCsvData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<V1ControllerFeedCsvResponses, V1ControllerFeedCsvErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/feed-csv',
        ...options
    });
};

/**
 * Get product feed as JSON
 * Retrieves a JSON feed of product images grouped by product. Returns all images for up to 30,000 products. Only products with at least one image modified since the specified date are included. Supports pagination via limit and offset.
 */
export const v1ControllerFeedJson = <ThrowOnError extends boolean = false>(options: Options<V1ControllerFeedJsonData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<V1ControllerFeedJsonResponses, V1ControllerFeedJsonErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/feed-json',
        ...options
    });
};

/**
 * Health check
 */
export const aiCrewControllerHealth = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerHealthResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/health',
        ...options
    });
};

/**
 * Daily breakdown of images captured and credits spent, by payment source
 */
export const aiCrewControllerImagesByPaymentSource = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerImagesByPaymentSourceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerImagesByPaymentSourceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/reports/images-by-payment-source',
        ...options
    });
};

/**
 * List all organizations
 */
export const aiCrewControllerListOrganizations = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListOrganizationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListOrganizationsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/organizations',
        ...options
    });
};

/**
 * List products, optionally filtered by organization, user email, or both
 */
export const aiCrewControllerListProducts = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListProductsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/products',
        ...options
    });
};

/**
 * Get a single product
 */
export const aiCrewControllerGetProduct = <ThrowOnError extends boolean = false>(options: Options<AiCrewControllerGetProductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AiCrewControllerGetProductResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/products/{productId}',
        ...options
    });
};

/**
 * List images for a product
 */
export const aiCrewControllerListProductImages = <ThrowOnError extends boolean = false>(options: Options<AiCrewControllerListProductImagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AiCrewControllerListProductImagesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/products/{productId}/images',
        ...options
    });
};

/**
 * List latest export tasks across all organizations
 */
export const aiCrewControllerListExportTasks = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListExportTasksData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListExportTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/export-tasks',
        ...options
    });
};

/**
 * List errors for a specific export task
 */
export const aiCrewControllerListExportTaskErrors = <ThrowOnError extends boolean = false>(options: Options<AiCrewControllerListExportTaskErrorsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AiCrewControllerListExportTaskErrorsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/export-tasks/{id}/errors',
        ...options
    });
};

/**
 * List recent export errors across all organizations
 */
export const aiCrewControllerListExportErrors = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListExportErrorsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListExportErrorsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/export-errors',
        ...options
    });
};

/**
 * List all users across organizations
 */
export const aiCrewControllerListUsers = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListUsersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/users',
        ...options
    });
};

/**
 * List recently created users
 */
export const aiCrewControllerListNewUsers = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListNewUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListNewUsersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/users/new',
        ...options
    });
};

/**
 * List transactions across all organizations
 */
export const aiCrewControllerListTransactions = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListTransactionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListTransactionsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/transactions',
        ...options
    });
};

/**
 * List device sessions across all organizations
 */
export const aiCrewControllerListDeviceSessions = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListDeviceSessionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListDeviceSessionsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/device-sessions',
        ...options
    });
};

/**
 * Overview of processing options used by a user (email or userId) or a whole organization (orgId), grouped by day, mode, and options
 */
export const aiCrewControllerGetProcessingOptionsOverview = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerGetProcessingOptionsOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerGetProcessingOptionsOverviewResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/processing-options',
        ...options
    });
};

/**
 * List unclaimed Stripe payments
 */
export const aiCrewControllerListUnclaimedStripePayments = <ThrowOnError extends boolean = false>(options?: Options<AiCrewControllerListUnclaimedStripePaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AiCrewControllerListUnclaimedStripePaymentsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/unclaimed-stripe-payments',
        ...options
    });
};

/**
 * Estimate credits and duration for a processing call without running it. Not quota-gated.
 */
export const aiCrewProcessingControllerGetPrice = <ThrowOnError extends boolean = false>(options: Options<AiCrewProcessingControllerGetPriceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AiCrewProcessingControllerGetPriceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/processing/price',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Process an image and return the result inline (base64). Gated by a global daily quota; nothing is persisted.
 */
export const aiCrewProcessingControllerProcess = <ThrowOnError extends boolean = false>(options: Options<AiCrewProcessingControllerProcessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AiCrewProcessingControllerProcessResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/ai-crew/processing/process',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Describe a pending authorization request for the consent page
 */
export const oauthControllerAuthorizeContext = <ThrowOnError extends boolean = false>(options: Options<OauthControllerAuthorizeContextData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<OauthControllerAuthorizeContextResponses, unknown, ThrowOnError>({
        url: '/api/oauth/authorize/context',
        ...options
    });
};

/**
 * Approve or deny a pending authorization request
 */
export const oauthControllerDecide = <ThrowOnError extends boolean = false>(options: Options<OauthControllerDecideData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OauthControllerDecideResponses, unknown, ThrowOnError>({
        url: '/api/oauth/authorize/decision',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the current user's connected MCP clients
 */
export const oauthControllerListSessions = <ThrowOnError extends boolean = false>(options?: Options<OauthControllerListSessionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<OauthControllerListSessionsResponses, unknown, ThrowOnError>({
        url: '/api/oauth/sessions',
        ...options
    });
};

/**
 * Revoke a connected MCP client session
 */
export const oauthControllerRevokeSession = <ThrowOnError extends boolean = false>(options: Options<OauthControllerRevokeSessionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<OauthControllerRevokeSessionResponses, unknown, ThrowOnError>({
        url: '/api/oauth/sessions/{id}',
        ...options
    });
};